export const itemGroupsActionTypes = {
  START_GET_ITEM_GROUPS: "START_GET_ITEM_GROUPS",
  GET_ITEM_GROUPS_SUCCESS: "GET_ITEM_GROUPS_SUCCESS",
  GET_ITEM_GROUPS_FAILURE: "GET_ITEM_GROUPS_FAILURE",

  START_CONNECT_ITEM_GROUP_WITH_CATEGORY: "START_CONNECT_ITEM_GROUP_WITH_CATEGORY",
  CONNECT_ITEM_GROUP_WITH_CATEGORY_SUCCESS: "CONNECT_ITEM_GROUP_WITH_CATEGORY_SUCCESS",
  CONNECT_ITEM_GROUP_WITH_CATEGORY_FAILURE: "CONNECT_ITEM_GROUP_WITH_CATEGORY_FAILURE",

  START_UPDATE_DISPLAY_ORDER: "START_UPDATE_DISPLAY_ORDER",
  UPDATE_DISPLAY_ORDER_SUCCESS: "UPDATE_DISPLAY_ORDER_SUCCESS",
  UPDATE_DISPLAY_ORDER_FAILURE: "UPDATE_DISPLAY_ORDER_FAILURE",

  START_DISCONNECT_ITEM_GROUP_FROM_CATEGORY: "START_DISCONNECT_ITEM_GROUP_FROM_CATEGORY",
  DISCONNECT_ITEM_GROUP_FROM_CATEGORY_SUCCESS: "DISCONNECT_ITEM_GROUP_FROM_CATEGORY_SUCCESS",
  DISCONNECT_ITEM_GROUP_FROM_CATEGORY_FAILURE: "DISCONNECT_ITEM_GROUP_FROM_CATEGORY_FAILURE",

  UPDATE_ITEM_GROUPS_LOCALLY: "UPDATE_ITEM_GROUPS_LOCALLY",
};
